Object.clone = function(object) {
  if (object != null) {
    return JSON.parse(JSON.stringify(object));
  }
  else {
    return object;
  }
}